import {type AxiosError, isAxiosError, isCancel} from 'axios';

import {ErrorResponse} from '@/domain';
import {isKeyInObject, isObject} from '@/shared/lib/object';

export function isHttpError(error: unknown) {
  return isAxiosError(error);
}

export function isApiError(error: unknown): error is AxiosError<ErrorResponse> {
  return (
    isKeyInObject('isAxiosError', error) &&
    Boolean(error.isAxiosError) &&
    isKeyInObject('response', error) &&
    isObject(error.response)
  );
}

export function isCancelError(
  error: unknown
): error is AxiosError<ErrorResponse> {
  return isCancel(error);
}
